import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import { Button } from '@blueprintjs/core'
import {FieldRendererStore, useFieldRendererStore, useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import {guid} from '@utils'
import SunEditor from 'suneditor-react'
import SetOptions from 'suneditor-react/dist/types/SetOptions'
import * as css from './CatalogFieldRendererEditableHtml.css'

/// region Store

export class CatalogFieldRendererEditableHtmlStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'> & { fieldStore: FieldRendererStore }) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @observable myEditorOptions: SetOptions = {
    resizingBar: false,
    buttonList: [
      ['undo', 'redo', 'font', 'fontSize', 'formatBlock'],
      ['bold', 'underline', 'italic', 'strike', 'removeFormat'],
      ['fontColor', 'hiliteColor', 'outdent', 'indent', 'align', 'horizontalRule', 'list', 'table'],
      ['link']
    ]
  }

  // @observable focused = false
  // @action onEditorFocus = () => {
  //   this.focused = true
  // }

  // @action onEditorBlur = _.debounce(() => {
  //   if (!DEBUG) {
  //     this.focused = false
  //   }
  // }, 100)

  @computed get showToolbar() {
    return this.fieldStore.isModal
  }

  get fieldStore() { return this.props.fieldStore}

  @action onChangeHtml = (html) => {
    const {fieldStore: {value, onChangeEditableField, detailsStore: {sidebar}}} = this
    if (!value.val && html === '<p><br></p>') return // Stupid suneditor gives us this when we switch their content back to null or ''
    if (html != value.val) {
      onChangeEditableField(html)

      // console.log(sidebar)
      if (sidebar?.type === 'sidebar' || sidebar?.type === 'modal') {
        this.onSave()
      }
    }
  }

  @action onCancel = () => {
    this.fieldStore.onCancelEditableField()
  }

  @action onSave = () => {
    this.fieldStore.commitEditableFieldChanges()
  }

  @computed get originalHtmlContent() {
    const {props: {fieldStore: {originalValue}}} = this
    return originalValue?.val
  }

  @computed get htmlContent() {
    const {props: {fieldStore: {editableFieldText, value}}} = this
    return editableFieldText?.value ?? value?.val
  }
}

export const CatalogFieldRendererEditableHtmlStoreContext = React.createContext<CatalogFieldRendererEditableHtmlStore>(null)
export const useCatalogFieldRendererEditableHtmlStore = () => React.useContext(CatalogFieldRendererEditableHtmlStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const CatalogFieldRendererEditableHtml = observer<MyProps>(function CatalogFieldRendererEditableHtml({className, ...props}) {
  const fieldStore = useFieldRendererStore(),
    obsProps = useAsObservableSource({...props, fieldStore}),
    store = useVipLocalStore((stores) => new CatalogFieldRendererEditableHtmlStore(stores, obsProps)),
    {htmlContent, props: {fieldStore: { isDirty}}, myEditorOptions, showToolbar, onChangeHtml, onCancel, onSave} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <CatalogFieldRendererEditableHtmlStoreContext.Provider value={store}>
      <div
        className={classNames(css.root, className)}
        // data-focused={focused}
        data-hide-toolbar={!showToolbar}
        data-dirty={isDirty}
      >
        <SunEditor
         // onFocus={onEditorFocus}
          // onBlur={onEditorBlur}
          //ref={setEditor}
          setContents={htmlContent ?? ''}
          setOptions={myEditorOptions}
          onChange={onChangeHtml}
          hideToolbar={!showToolbar}
          disableToolbar={!showToolbar}
          height={'auto'}
        />

        <div className={css.footer}>
          <Button text='Cancel' onClick={onCancel} />
          <Button text='Save' onClick={onSave}/>
        </div>
      </div>
    </CatalogFieldRendererEditableHtmlStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/CatalogFieldRendererEditableHtml.tsx